export default __webpack_public_path__ + "static/media/icon_schedule_cross.3322db5e.svg";